/**
 * Created by ShaunBetts on 14-May-16.
 */

//These Are Globals Available From Webpack
  //HOST_SECURE,HOST_STATIC,HOST_EXTERNAL

//Base URI's
export const STATIC_URI = '//' + HOST_STATIC + '/';
export const STATIC_IMAGE_URI = STATIC_URI + 'image/';
export const STATIC_REPORT_PACK_URI = STATIC_URI + 'reportPackTemplates/';

//Base Values
export const MAX_AGG_COUNT = 1000;

//Main Types
export const COMPANY = 'company';
export const QUOTE = 'quote';
export const USER = 'user';
export const FORM = 'form';

//states
export const COMPOSITE = 'COMPOSITE';
export const EMPTY = 'EMPTY';
export const LOADING = 'LOADING';
export const UPDATING = 'UPDATING';
export const PENDING = 'PENDING';
export const READY = 'READY';
export const COMPLETE = 'COMPLETE';
export const ERROR = 'ERROR';
export const PAUSE = 'PAUSE';
export const PAUSED = 'PAUSED';
export const STOP = 'STOP';
export const STOPPED = 'STOPPED';
export const DELETED = 'DELETED';

export const VALID_STATES = [COMPOSITE, EMPTY, LOADING, READY, ERROR];

//workflow states
export const WORKFLOW_STATE_ONGOING = 'ongoing';
export const WORKFLOW_STATE_ON_HOLD = 'on_hold';
export const WORKFLOW_STATE_DECLINED = 'declined';
export const WORKFLOW_STATE_COMPLETE = 'complete';

//material states
export const MATERIAL_STATE_ESTIMATED = 'ESTIMATED';
export const MATERIAL_STATE_ESTIMATOR_CONFIRMED = 'ESTIMATOR_CONFIRMED';
export const MATERIAL_STATE_SUPPLIER_TENDER = 'SUPPLIER_TENDER';
export const MATERIAL_STATE_QUOTED = 'QUOTED';
export const MATERIAL_STATE_BUILDER_DECISION = 'BUILDER_DECISION';
export const MATERIAL_STATE_CUSTOMER_DECISION = 'CUSTOMER_DECISION';
export const MATERIAL_STATE_ORDERED = 'ORDERED';
export const MATERIAL_STATE_DELIVERED = 'DELIVERED';
export const MATERIAL_STATE_BUILDER_HAS_LEFTOVER_STOCK = 'BUILDER_HAS_LEFTOVER_STOCK';
export const MATERIAL_STATE_LOST_PAST_BUILD_STAGE = 'LOST_PAST_BUILD_STAGE';
export const MATERIAL_STATE_LOST_TO_COMPETITOR = 'LOST_TO_COMPETITOR';
export const MATERIAL_STATE_DEFAULT = 'DEFAULT';
export const MATERIAL_STATE_NOT_TO_SPEC = 'NOT_TO_SPEC';
export const MATERIAL_STATE_TO_SPEC = 'TO_SPEC';
export const MATERIAL_STATE_ESTIMATED_ONLY = 'ESTIMATED_ONLY';
export const MATERIAL_STATE_NOT_REQUIRED = 'NOT_REQUIRED';
export const MATERIAL_STATE_SALES_CONFIRMED = 'SALES_CONFIRMED';
export const MATERIAL_STATE_NOT_ON_PLANS = 'NOT_ON_PLANS';
export const MATERIAL_STATE_DIRECT_TO_SITE = 'DIRECT_TO_SITE';
export const MATERIAL_STATE_DESIGN_AND_PRICE = 'DESIGN_AND_PRICE';
export const MATERIAL_STATE_BUILDER_TO_CHECK = 'BUILDER_TO_CHECK';
export const MATERIAL_STATE_PRICE_INSTABILITY = 'PRICE_INSTABILITY';
export const MATERIAL_STATE_SUBSTITUTE = 'SUBSTITUTE';

//Contact Type
export const CONTACT_BUILDER = 'builder';
export const CONTACT_BUILDER_SECONDARY = 'builderSecondary';
export const CONTACT_BRANCH = 'branchContact';

export const VALID_WORKFLOW_STATES = [WORKFLOW_STATE_ONGOING, WORKFLOW_STATE_ON_HOLD, WORKFLOW_STATE_DECLINED, WORKFLOW_STATE_COMPLETE];

//sign in states
export const SIGNED_IN = 'SIGNED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_IN_TOKEN_REQUIRED = 'SIGN_IN_TOKEN_REQUIRED';

//store
export const STORE_CLEAR_ERROR = 'CLEAR_ERROR';

//electron events
export const EVENT_ELECTRON_READY = 'electronReady';
export const EVENT_ELECTRON_SETTINGS_LOADED = 'electronSettingsLoaded';
export const EVENT_ELECTRON_STORE_DISPATCH = 'electronStoreDispatch';
export const EVENT_ELECTRON_TASK_UPDATE = 'electronTaskUpdate';
export const EVENT_ELECTRON_TASK_SKIP = 'electronTaskSkip';

export const EVENT_CLIENT_READY = 'clientReady';
export const EVENT_CLIENT_SETTINGS_CHANGE = 'clientSettingsChange';
export const EVENT_CLIENT_TASK_START = 'clientTaskStart';
export const EVENT_CLIENT_TASK_UPDATE = 'clientTaskUpdate';
export const EVENT_CLIENT_TASK_RETRY = 'clientTaskRetryStep';
export const EVENT_CLIENT_TASK_NEXT = 'clientTaskNextStep';
export const EVENT_CLIENT_TASK_RESET = 'clientTaskReset';
export const EVENT_CLIENT_TASK_PAUSE = 'clientTaskPause';
export const EVENT_CLIENT_TASK_STOP = 'clientTaskStop';
export const EVENT_CLIENT_TOGGLE_EXCEL = 'clientToggleExcel';
export const EVENT_CLIENT_CLEAR_DOWNLOADS = 'clientClearDownloads';

//breakpoints
export const MOBILE_WIDTH = 600;

export const DEVICE_TYPE_DESKTOP = 'desktop';
export const DEVICE_TYPE_TABLET = 'tablet';
export const DEVICE_TYPE_MOBILE = 'mobile';

//Brands
export const JEWSON = 'Jewson';
export const GIBBS = 'Gibbs & Dandy';
export const JP_CORRY = 'JP Corry';

//External quotes states
export const NOT_REQUIRED = 'NOT_REQUIRED';
export const REQUIRED = 'REQUIRED';
export const DECLINED = 'DECLINED';
export const ORDERED = 'ORDERED';
export const QUOTED = 'QUOTED';
export const DISABLED = ['NOT_REQUIRED', 'DECLINED'];
export const ENABLED = ['REQUIRED', 'QUOTED', 'ORDERED'];
export const QUOTED_STATES = ['QUOTED', 'ORDERED'];
export const INTERNAL_ONLY = 'internalOnly';
export const EXTERNAL_ONLY = 'externalOnly';
export const INTERNAL_AND_EXTERNAL = 'internalAndExternal';